<template>
  <v-row justify="center">
    <v-col cols="12" sm="7" md="4">
      <v-card :flat="isMobile" max-width="500" class="mx-auto">
        <v-card-title> User Registration </v-card-title>

        <v-card-text class="py-0"
          ><v-form ref="formGeneralData" v-model="formValidation"
            ><v-row no-gutters>
              <v-col cols="12">
                <v-text-field
                  v-model="user.name"
                  label="Name*"
                  color="companyPrimary"
                  outlined
                  dense
                  autofocus
                  :rules="[rules.required]"
                ></v-text-field
              ></v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="user.surname"
                  label="Surname*"
                  color="companyPrimary"
                  outlined
                  dense
                  :rules="[rules.required]"
                ></v-text-field
              ></v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="user.email"
                  label="E-mail*"
                  color="companyPrimary"
                  outlined
                  dense
                  type="email"
                  :rules="[rules.required, rules.email]"
                  @click.right.prevent
                  @copy.prevent
                  @paste.prevent
                ></v-text-field
              ></v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="confirmMail"
                  label="Confirm E-mail*"
                  color="companyPrimary"
                  outlined
                  dense
                  type="email"
                  :rules="[
                    rules.required,
                    rules.email,
                    rules.confirmEmail(confirmMail, user.email),
                  ]"
                  @click.right.prevent
                  @copy.prevent
                  @paste.prevent
                ></v-text-field
              ></v-col>
            </v-row> </v-form
        ></v-card-text>
        <v-card-text>
          By clicking Agree & Register, you agree to the
          {{ getLegalEntity.label }} Italia Srl
          <router-link :to="{ name: 'privacy-policy' }"
            >Privacy & Cookie Policy</router-link
          >, and
          <router-link :to="{ name: 'privacy-policy-careers' }"
            >Careers Privacy Policy</router-link
          >.
        </v-card-text>
        <v-card-actions>
          <v-btn
            :disabled="!formValidation"
            block
            color="primary"
            @click="registerUser"
          >
            Agree & Register
          </v-btn></v-card-actions
        >
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import { validationRules } from "@/utils/validation-rules";
import { getCodeLabelSelectItems, getLabel } from "@/utils/enums";
import { RegistrationService } from "@/services";

export default {
  name: "RegistrationView",
  data() {
    return {
      formValidation: true,
      isSaveOngoing: false,

      confirmMail: null,

      user: {
        name: "",
        surname: "",
        email: "",
        competenceCenter: null,
      },

      rules: { ...validationRules },

      getCodeLabelSelectItems,
      getLabel,
    };
  },
  computed: {
    ...mapGetters("domain", ["getLegalEntity"]),
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
  },
  mounted() {
    if (this.$route.query.position == null && this.$route.query.role == null) {
      this.$router.push({ name: "login" });
    }
  },
  methods: {
    async registerUser() {
      this.isSaveOngoing = true;
      await RegistrationService.register(
        this.user,
        this.$route.query.position,
        this.$route.query.role
      );
      this.isSaveOngoing = false;
    },
  },
};
</script>
